import { combineReducers } from "redux";
import wallet from "./wallet";
import networkSwitching from "./networkSwitch";

export default combineReducers({
    wallet : wallet,
    networkSwitching:networkSwitching
});